<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <PaintingRoom/>
  </div>
</template>

<script>
import PaintingRoom from './components/PaintingRoom.vue'

export default {
  name: 'App',
  components: {
    PaintingRoom
  }
}
</script>

<style>
body {
  margin: 0;
}

</style>
